export default __webpack_public_path__ + "static/media/1089.697ca0eb.png";